import ActionSelectorInput from "@builder/components/general/ActionSelectorInput";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { EditableProps } from "../../editableProps";

const EditAction: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    return (
        <SidebarCollapse title="Action" parent={parent}>
            <ActionSelectorInput />
        </SidebarCollapse>
    );
};

export default EditAction;
